import React from "react";
import "./About.scss";

const TECH_ITEMS = [
  "React.js",
  "TypeScript",
  "JavaScript",
  "NodeJs",
  "Braze",
  "Linux",
  "AWS",
  "MySQL",
  "RESTful APIs",
];

const About = () => {
  return (
    <div className="about-container">
      <div className="about-content">
        <div className="about-text">
          <p>
          am a software engineer at{" "}
          <a
            href="https://www.massiverocket.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="company-link"
          >
            Massive Rocket
          </a>{" "}
          (remote grind 💻 ), with <b>5+ years</b> of experience in software engineering, including building CRM systems, in-app experiences, games, and scalable architecture while diving deep into full-stack dev.
          </p>
          <p>
          currently exploring the AI rabbit hole—building AI agents and experimenting with AI-native ways to design, build, and ship software.
          </p>
          <p>
          outside of work? finance, tech, music, or planning my next getaway. ✈️
          </p>
        </div>

        <div className="tech-section">
          <h2 className="tech-heading">technologies I work with;</h2>

          <div className="tech-card">
            {TECH_ITEMS.map((item) => (
              <span className="tech-item" key={item}>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
